// import logo from './logo.svg';
import './App.css'; 
import { Box, Typography } from '@mui/material';

function App() {
  return (
    <div className="App">
      {/* <header className="App-header"> */}

        {/* <img src={logo} className="App-logo" alt="logo" /> */}
        <Box
          sx={{
            minHeight: '100vh',
            width: '100%',
            backgroundImage: `url('/brick.jpg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            justifyContent: 'center',
            boxSizing: 'border-box',
          }}
        >
          <Box
            component="img"
            src="/sign1.jpg"
            alt="sign"
            sx={{
              width: '100%',
              height: 'auto',
              display: 'block',
            }}
          />
          <Typography variant="h1" component="h1" sx={{ fontSize: '2rem', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', textAlign: 'center', color: 'black', marginTop: 2 }}>
            Coming Soon
          </Typography>
        </Box>
      {/* </header> */}
    </div>
  );
}

export default App;
